@if (meeting) {
    <div class="progress-indicator-container"
         #progressIndicator
         role="button">
        <svg [attr.width]="radius * 2"
             [attr.height]="radius * 2"
             [attr.viewBox]="'0 0 ' + radius * 2 + ' ' + radius * 2">
            <!-- Background circle -->
            <circle [attr.cx]="radius"
                    [attr.cy]="radius"
                    [attr.r]="radius"
                    class="background-circle"></circle>

            <!-- Progress pie slice -->
            <path [attr.d]="describePieSlice(angle)"
                  class="progress-fill"
                  [ngClass]="statusFillClass"></path>
        </svg>

        <div class="d-flex"
             [ngClass]="{
                'flex-column ms-1': !singleRow,
                'flex-row gap-1': singleRow,
            }"
             [class.text-nowrap]="!singleRow">
            @if (showElapsedTime) {
                <span>Elapsed:</span>
                <span>{{ elapsedTimeText }}</span>
            } @else {
                <span>Ends at:</span>
                <span>{{ estimateEndTime | adaptTime }}</span>
            }
        </div>
    </div>

    <dx-popover [target]="progressIndicator"
                showEvent="dxhoverstart"
                hideEvent="dxhoverend">
        <div *dxTemplate="let data of 'content'"
             class="d-flex flex-column">
            <span><strong>Start time:</strong> {{ meeting.extensions.startTime | adaptDateTime }}</span>
            <span><strong>Scheduled end time:</strong> {{ meeting.endTime | adaptTime }}</span>
            <span><strong>Estimated end time:</strong> {{ estimateEndTime | adaptTime }}</span>
            <span><strong>Status:</strong> {{ MeetingStatusText[statusFillClass] }}</span>
            <span><strong>Elapsed time:</strong> {{ elapsedTimeText }}</span>
            <small class="mt-2">Click to toggle between elapsed time and estimated end time</small>
        </div>
    </dx-popover>
}
